import { HttpRequest } from './HttpRequest'

export const SapApproveByUnitId = async (object: { approveAmount: string, unitId: number }) => {
    let data = JSON.stringify(object);
    try {
        const response = await HttpRequest().post(`/sap/approve`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (response.data.message === 'updated') {
            return "updated"
        }
    } catch (error: any) {
        if (error.response.status === 400) return error.response.data.message
        throw new Error('error api /planning/transfer/save')
    }
}